export const navList = [
    { navName: "Strona Główna", path: "/", end: true },
    { navName: "O mnie", path: "/o-mnie" },
    { navName: "Oferta", path: "/oferta" },
    { navName: "Portfolio", path: "/portfolio" },
    { navName: "Kontakt", path: "/kontakt" },
];